import cx, { clsx } from 'clsx';
import type { StyleableProps } from '@kcd/design-system/dist/types/utils';

import type { OAISchema } from '~/types/openapi';

import MembershipTotalDiscountAmount from '../MembershipTotalDiscountAmount';

type Props = OAISchema['MarketSelectProductResponseV2'] & {
  reverse?: boolean;
  wFull?: boolean;
  is3x2?: boolean;
} & StyleableProps;

const MembershipDiscountedPrice = ({
  price,
  reverse = false,
  productType,
  totalDiscountedPrice,
  totalDiscountAmount,
  className,
  wFull = true,
  is3x2 = false,
}: Props) => {
  const isECoupon = productType === 'E_COUPON';

  if (!totalDiscountAmount) {
    return (
      <p
        className={clsx('mt-4 text-gray-1400', className)}
        style={{ fontSize: '16px', fontWeight: '700', lineHeight: '20px' }}
      >
        {price === 0 ? '상담신청 상품' : `${price.toLocaleString()}원`}
      </p>
    );
  }

  return (
    <div className={className}>
      <div className="text-description typo-footnote300-regular">
        {price.toLocaleString()}원
      </div>
      <div
        className={cx([
          reverse &&
            'inline-flex flex-row-reverse gap-[2px] mr-auto items-center whitespace-nowrap',
        ])}
      >
        <div className="text-membershipBlue-text typo-caption100-semibold">
          나의할인가
        </div>
        <div
          className="text-membershipBlue-text"
          style={{ fontSize: '16px', fontWeight: '700', lineHeight: '20px' }}
        >
          {totalDiscountedPrice?.toLocaleString()}원
        </div>
      </div>
      {!isECoupon && (
        <MembershipTotalDiscountAmount
          totalDiscountAmount={totalDiscountAmount}
          wFull={wFull}
          is3x2={is3x2}
        />
      )}
    </div>
  );
};

export default MembershipDiscountedPrice;
